import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@atoms/Button";
import Link from "@atoms/Link";

import CheckoutIntl from "@pages/Checkout/CheckoutIntl";
import CheckoutKr from "@pages/Checkout/CheckoutKr";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

import { useCartStore } from "@store/cart";
import { useLayoutStore } from "@store/layout";

export default function Checkout() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { cart } = useCartStore();
  const { showFooter } = useLayoutStore();

  useEffect(() => {
    showFooter(false);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (lang !== "jp") return;
    window.location.href = cart.checkoutUrl || URLS.HOME;
  }, [lang, cart.checkoutUrl]);

  if (lang === "jp") return null;

  return (
    <section className="pc:col-start-3 pc:w-full pc:min-w-160 pc:max-w-200 pc:place-self-center relative col-span-8 flex flex-col">
      <section className="flex items-center justify-between p-5">
        <Link className="text-title font-features-normal" href={URLS.HOME}>
          thisisneverthat®
        </Link>
      </section>

      <section className="flex flex-col gap-5 p-5">
        <Button
          as="text"
          onClick={() => {
            const checkoutBackUrl = sessionStorage.getItem("checkoutBackUrl");
            if (checkoutBackUrl) navigate(checkoutBackUrl);
            else navigate(-1);

            sessionStorage.removeItem("checkoutBackUrl");
          }}
        >
          ← Back
        </Button>
        {lang === "ko" ? <CheckoutKr /> : <CheckoutIntl />}
      </section>
    </section>
  );
}
